import { createAppLogging } from '@ahaslides-product/frontend-toolkit'
import config from '@/config'
import sentry from '@/services/sentry'

export default createAppLogging({
  config,
  service: 'presenter',
  flag: 'AHA-35479-presenter-remote-logging',
  ignoredActions: ['kvSync/updateKeyValueAction'],
  slideActions: ['patchSlideByIdAction', 'setSlideActiveAction', 'categorise/subscribeCategoriseStatsAction'],
  contextActions: {
    setPresentationAction: (presentation) => ({ presentationId: presentation?.id }),
  },
  // Page load commits setCurrentUser directly, so no action carries the user id.
  contextMutations: {
    setCurrentUser: (user) => ({ userId: user?.id }),
  },
  getTraceId: sentry.getTraceId,
  captureException: sentry.captureException,
})
